import ActionMap from './_ActionMap.vue';
import ActionAdder from './_ActionAdder.vue';
export default {
  name: 'ActionMapper',
  props: ['feed_id', 'mock_data', 'actions', 'all_actions'],
  components: {
    ActionMap: ActionMap,
    ActionAdder: ActionAdder
  },
  data: function data() {
    return {
      show_adder: false
    };
  },
  methods: {
    appendAction: function appendAction(action) {
      this.show_adder = false;
      action.feed_id = this.feed_id;
      this.actions.push(action);
    },
    triggerUpdate: function triggerUpdate() {
      this.$emit('update');
    }
  },
  mounted: function mounted() {
    if (!this.actions.length) {
      this.show_adder = true;
    }
  }
};